module.exports = __webpack_public_path__ + "img/t3-4.3fcd06cd.svg";